module.exports = __webpack_public_path__ + "static/img/s2model3.b1b6112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/model/s2model3.png
// module id = BVld
// module chunks = 0